import EL, { HTMLELEMENT } from '../../EL/EL.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
// Model Structure
export const progressAttr = makeAttrStruct([
    ['value', 0],
    ['max', 100]
]);
export const progressData = makeDataStruct();
export const progressModel = makeStruct([
    ['attributes', progressAttr()],
    ['data', progressData()],
    ['meta', () => ({})] // default meta
]);
// Simplified Model
export function progress(value = 0, max = 100) {
    return {
        attributes: progressAttr(value, max),
        data: progressData()
    };
}
/** A Progress Bar / Loader */
export default class PROGRESS extends EL {
    constructor(node, model) {
        super(node, HTMLELEMENT.PROGRESS, model);
    }
    /** Sets the value of the progress bar */
    setValue(value) {
        this.setAttribute('value', value);
        return this.setText(value.toString());
    }
    /** Sets the text in the progress bar */
    setText(text) {
        return this.setInnerHTML(text);
    }
}
